import { BaseModel } from './base-model';
import { ModelConfig } from './model-config';

export class SubscriptionItem extends BaseModel{

  name() {
    return this.get("name");
  }

  static create(attribs: Object) {
    return new SubscriptionItem(attribs);
  }

  constructor(loadAttribs: object) {

      // define permitted attributes.
      let config = new ModelConfig();
      config.permittedAttribs = [
          "id", "hidden", "name", "alternateName", "sku", "price",
          "priceType", "defaultTaxRates", "cost", "isRevenue",
          "modifiedTime"
      ];

      // instantiate BaseModel.
      super(config);

      // load any passed in attribs.
      if(typeof loadAttribs === "object" && Object.keys(loadAttribs).length)
      {
        super.load(loadAttribs);
      }
  }
}



// WEBPACK FOOTER //
// ./src/models/subscription-item.ts